<template>
  <div class="card border-radius-none">
    <div class="commandes__produits card-article">
      <div class="commandes__details">

        <div v-if="!ligneCommande.referencePersonnalise"
          class="commandes__ligne-selecteurs" style='--margin: 15px 0 0 0;'>
          <b-icon class="drag" icon="drag"
                  :class="{
                    'pointer-no-drop' : disabledDraggable,
                    'draggable-handle' : !disabledDraggable
                  }">
          </b-icon>
          <b-checkbox v-model="ligneCommande.selected" :disabled="disabled">
          </b-checkbox>
        </div>
        <div v-else class="commandes__ligne-selecteurs mgr-30px">
          <b-icon class="has-text-primary" icon="subdirectory-arrow-right"></b-icon>
        </div>

        <div class='search'>
          <b-field :label="$t('detail.article.product')"
            custom-class="is-size-7 is-marginless has-text-link">
            <b-autocomplete
              :placeholder="$t('detail.article.search')"
              v-model="ligneCommande.search"
              :keep-first="keepFirst"
              :open-on-focus="openOnFocus"
              :data="typesProduit"
              :ref="'autocomplete_' + ligneCommande.ordre"
              field="title"
              :disabled="(isCreditNote && !isAvoirLibre) || disabled"
              @select="selectedProduct"
              @input="searchProduct()">
              <template slot="empty">
                <div v-if="fetched">{{$t('detail.article.noResult')}}</div>
                <div v-else>{{$t('detail.article.search')}}</div>
              </template>
              <template slot-scope="props">
                <div class="dropdown-item  is-paddingless" v-if="props.option.id">
                  <div class="columns is-marginless is-multiline">
                    <div class="column pdv-0">
                      <span class="has-text-weight-bold">
                        {{props.option.title}}
                      </span>
                      <span v-if="props.option.titleEnfant">
                        &nbsp;➔&nbsp;{{props.option.titleEnfant}}
                      </span>
                    </div>
                    <div class="column is-12 is-size-8 pdv-0 "
                      v-if="props.option.adresse">
                      {{importedFunction.adressFullStringGetter(props.option.adresse)}}
                    </div>
                  </div>
                </div>
                <div v-else class="dropdown-item is-disabled is-paddingless">
                  {{$t(props.option.title)}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
        </div>

        <div class="commandes__ligne-libelle mgl-10px" style='--basis: 20%;'>
          <b-field custom-class="is-size-7 is-marginless has-text-link"
            :label="$t('detail.article.libelle')">
            <b-input v-model="ligneCommande.libelle"  :disabled="disabled"
            type="textarea" :rows="nbLignesLibelle">
            </b-input>
          </b-field>
        </div>

        <div class='fields mgl-10px d-flex' style='--x-start:4; --x-end: span 2;'>

          <div class="mgr-10px">
            <b-field :label="$t('detail.article.quantite')"
                    custom-class="is-size-7 is-marginless has-text-link">
              <b-field class="is-marginless is-paddingless" >
                <input-currency ref="quantite" v-model="ligneCommande.quantite" :disabled="disabled"
                  isNumber="true" style='--max-width: 60px;' class='commandes__ligne--is-max'
                  :peutEtreNegatif="true"
                  @input="calcul()">
                </input-currency>
                <p class="control" >
                  <b-dropdown position="is-bottom-left" :disabled="disabled">
                    <button class="button select pdl-5px width-50px" slot="trigger">
                      <span class="is-pulled-left">{{$t(unite)}}</span>
                    </button>
                    <b-dropdown-item v-for="unite in listeUniteQuantite"
                      :key="unite.code"
                      v-model="unite.code"
                      @click="changerUnite(unite)">
                      {{$t(unite.initiale)}} ({{$t(unite.libelle)}})
                    </b-dropdown-item>
                  </b-dropdown>
                </p>
              </b-field>
            </b-field>
          </div>

          <div class="mgr-10px">
            <b-field :label="$t('detail.article.priceUnit')"
                custom-class="is-size-7 is-marginless has-text-link">
              <input-currency :disabled="disabled"
                class='commandes__ligne--is-max' style='--max-width: 120px;'
                ref="prixUnitaire" v-model="ligneCommande.prixUnitaire"
                isNumber="true"
                :peutEtreNegatif="true"
                @input="calcul()">
              </input-currency>
            </b-field>
          </div>

          <div class="mgr-10px">
            <b-field :label="$t('detail.article.montantBrut')"
                     custom-class="is-size-7 is-marginless has-text-link ellipsis">
              <input-currency
                style='--max-width: 70px;'
                disabled class="commandes__ligne--is-max"
                ref="montantBrut" :value="getMontantBrut"
                isNumber="true"
                :peutEtreNegatif="true">
              </input-currency>
            </b-field>
          </div>

          <div class="mgr-10px">
            <b-field :label="$t('detail.article.discount')"
                    custom-class="is-size-7 is-marginless has-text-link ellipsis">
              <b-field>
              <input-currency ref="remise" v-model="valeurPourcentage"
                isNumber="true" class='commandes__ligne--is-max' style='--max-width: 52px;'
                @input="calcul()"
                :disabled="estRemisePersonalisee() || disabled">
              </input-currency>
              <b-dropdown position="is-bottom-left" :disabled="disabled">
                <button class="button select pdl-5px width-55px" slot="trigger">
                  <span class="is-pulled-left">{{$t(typeRemiseInitial)}}</span>
                </button>
                <b-dropdown-item
                  v-for="typeRemise in listeTypeRemiseLigne"
                  :key="typeRemise.code"
                  v-model="typeRemise.code"
                  @click="changerTypeRemise(typeRemise)">
                  {{$t(typeRemise.libelle)}}
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>
            </b-field>
          </div>

          <div class="mgr-10px">
            <b-field :label="$t('detail.article.prixUnitaireNet')"
                     custom-class="is-size-7 is-marginless has-text-link ellipsis">
              <input-currency
                style='--max-width: 70px;'
                disabled class="commandes__ligne--is-max"
                :value="getPrixUnitaireNet(ligneCommande)"
                isNumber="true"
                :peutEtreNegatif="true">
              </input-currency>
            </b-field>
          </div>

          <div>
            <b-field :label="$t('detail.article.TauxTva')"
                    custom-class="is-size-7 is-marginless has-text-link">
              <div class="select">
                <select ref="tauxTva" v-model="ligneCommande.tauxTva" v-on:change="calcul"
                  :disabled="isCreditNote
                    || annonceurWithExonerationTva(ligneCommande)
                    || disabled">
                  <option v-for="tva in regimeTva"
                          :key="tva.tauxTva"
                          :value="tva.tauxTva">
                    {{ tva.tauxTva | formatPercent }}
                  </option>
                </select>
              </div>
            </b-field>
          </div>

        </div>
        <div class="dates mgl-10px"
             v-if="devisCommande.sens === constantes.SENS_ACHAT">
          <div class="card-article-input-selectDate columns is-vcentered">
            <div class="has-text-centered is-paddingless card-article-input-datepicker-empty">
              <a @click="showModalChangeDate = true">
                <b-icon
                  icon="calendar-clock"
                  type="is-white"
                  custom-class="mgt-10px">
                </b-icon>
              </a>
            </div>
            <div class="has-text-icon-more is-size-7 column is-narrow
                    is-paddingless card-article-input-dateRegroupAchat">
              {{ getDate }}
              <div v-if="getNumberDay">
                {{ $t('detail.article.numberDays', { nbJour: getNumberDay }) }}
              </div>
            </div>
          </div>
        </div>
        <div class="commandes__fin-ligne">

          <div class="has-text-weight-semibold">
            <span v-if="ligneCommande.totalHt" class="is-fullwidth ellipsis">
              {{ligneCommande.totalHt | formatDevise}}
            </span>
            <span v-else> {{ 0.00 | formatDevise }} </span>
          </div>
          <div>
            <a
              v-if="ligneCommande.typeProduit === constantes.CATEGORIE_DISPOSITIF"
              @click="toggleDetail()" class="iconArrowMenu"
              :class="{'iconRecouvrementArrowMenuOpen': openDetail}">
              <b-icon
                icon="arrow-right-drop-circle"
                type="is-default"
              >
              </b-icon>
            </a>
          </div>
          <b-dropdown position="is-bottom-left"
                       :disabled="disabled"
                       aria-role="list">
            <a slot="trigger">
              <b-icon
                custom-class="has-text-icon-more"
                icon="dots-vertical">
              </b-icon>
            </a>
            <b-dropdown-item aria-role="listitem" @click="inProgress()">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">{{ $t('detail.article.associate')}}</p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
            @click="openPopupForDuplicate(ligneCommande.referencePersonnalise)">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">
                    {{ $t('general.button.dupliquer')}}
                  </p>
                </div>
              </div>
            </b-dropdown-item>
            <b-dropdown-item aria-role="listitem"
                             :disabled="!canDelete"
                             ref="actionSupprimee"
                             @click="supprimerProduit()">
              <div class="media">
                <div class="media-content">
                  <p class="is-default font-dropdown">{{ $t('detail.article.delete')}}</p>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>

        </div>

      </div>
      <ligne-issue-commande v-if="devisCommande.references && devisCommande.references.length > 0
                              && ligneCommande.commandeId"
                            :is-edition="true"
                            :ligne-commande="ligneCommande"
                            :references-commande="devisCommande.references">
      </ligne-issue-commande>

      <div class='commandes__ligne pdb-0'
        v-if='ligneCommande.typeProduit === constantes.CATEGORIE_DISPOSITIF && openDetail'>
        <qd-collapse :open="openDetail" animation="slide-fade" class='full-width pd-0'>
          <hr class="is-marginless"/>
          <ligne-commande-dispositif
            :ligneCommandeDispositif="ligneCommande.ligneCommandeDispositif"
            :theme="devisCommande.theme"/>
        </qd-collapse>
      </div>
    </div>
    <b-modal v-model="isRemisesOpen"
      has-modal-card
      class="modal" @close="cancelRemise()">
      <app-lignes-remise :ligneCommande="ligneCommande"
                         :isReseauTempo="false"
        @validationRemise="validationRemise"
        @cancelRemise="cancelRemise()" />
    </b-modal>
    <b-modal v-model="showModalChangeDate"
             has-modal-card
             class="modal">
      <pop-up-edit-date-ligne :dates="{
       dateDebut: ligneCommande.dateDebut,
        dateFin: ligneCommande.dateFin}"
                              :commandeAchatARapprocher="commandeAchatARapprocher"
                              :devisCommande="devisCommande"
                              @updateDates="updateDates">
      </pop-up-edit-date-ligne>
    </b-modal>
    <b-modal v-model="popUpDuplicationLigne"
      class="modal"
      has-modal-card>
      <pop-up-duplication-ligne
        @makeDuplication="makeDuplication"
      />
    </b-modal>
    <b-modal v-model="errorPopUp"
             has-modal-card
             class="modal">
      <app-popup-erreur
        :messHeader="headerError"
      />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import inputCurrency from '@/components/general/inputCurrency';
import inProgress from '@/services/general/inProgress';
import lignesRemise from '@/components/devisCommandes/editionDevisCommande/lignesRemise';
import * as remiseF2B from '@/services/devisCommandes/traductionRemiseBackFront';
import { getAllProduct } from '@/services/devisCommandes/getAllProduct';
import * as devisConf from '@/configuration/devisConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { ajoutLignesCommandeProduitFace } from '@/services/devisCommandes/ajoutProduit/ajoutProduitFace';
import { ajoutLignesCommandeProduitReseauTempo } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauTempo';
import { ajoutLignesCommandeProduitReseauLc } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauLc';
import { ajoutLignesCommandeProduitReseauMairie } from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauMairie';
import copieReferencePersonnalise
  from '@/services/devisCommandes/regroupementPersonnalise/copieReferencePersonnalise';
import { ajoutLignesCommandeProduitReseauNumeriqueViaId }
  from '@/services/devisCommandes/ajoutProduit/ajoutProduitReseauNumerique';
import { ajoutLignesCommandeProduitEcranNumeriqueViaId }
  from '@/services/devisCommandes/ajoutProduit/ajoutProduitEcranNumerique';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { addReferenceEcheancierToLigneCommande }
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';
import deleteLignesEcheanciersInutiles from '@/services/commande/echeancierFacturation/deleteLignesEcheanciersInutiles';
import messageErreur from '@/services/general/messageErreur';
import ligneIssueCommande from '@/components/factures/editionFacture/ligneIssueCommande';
import updateInfoSousLigneRegroupement from '@/services/dcf/lignesDCF/updateInfoSousLigneRegroupement';
import updateModeCalculHonoraireLigneCommandeHonoraire from '@/services/ligneCommande/updateModeCalculHonoraire';
import calculArrondi from '@/services/calcul/calculArrondi';
import formatDate from '@/services/general/formatDate';
import calculDaysBetweenTwoDate from '@/services/general/calculDaysBetweenTwoDate';
import PopUpEditDateLigne from '@/components/baux/factureAchatARapprocher/edition/produit/p_editDateLigne';
import ligneCommandeDispositif from '@/components/devisCommandes/editionDevisCommande/m_ligneCommandeDispositif';
import {
  ajoutLignesCommandeProduitSalon,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitSalon';
import {
  ajoutLignesCommandeProduitSponsoring,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitSponsoring';
import {
  ajoutLignesCommandeProduitAutre,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitAutre';
import {
  ajoutLignesCommandeProduitPresse,
} from '@/services/devisCommandes/ajoutProduit/ajoutProduitPresse';
import { POURCENTAGE } from '@/configuration/devisConf';
import cloneDeep from 'lodash/cloneDeep';
import genererCommentaireVenteForLigne from '@/services/devisCommandes/ajoutProduit/genererCommentaireVente';
import popUpDuplicationLigne from '@/components/devisCommandes/editionDevisCommande/p_duplicationLigne';
import initialisationOptionBlocage
  from '@/services/devisCommandes/optionBlocage/initialisationOptionBlocage';
import getExonerationTva from '@/services/tiers/getExonerationTva';
import popupErreur from '@/components/general/popUpErreur';

const Societes = createNamespacedHelpers('societe');
const CategorieVente = createNamespacedHelpers('categorieVente');
const User = createNamespacedHelpers('user');

export default {
  props: {
    lignesCommande: Array,
    ligneCommande: Object,
    error: Boolean,
    devisCommande: Object,
    isCreditNote: Boolean,
    isAvoirLibre: {
      type: Boolean,
      default: false,
    },
    sens: String,
    disabledDraggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDelete: {
      type: Boolean,
      required: false,
      default: true,
    },
    commandeAchatARapprocher: {
      type: Array,
      required: false,
    },
    modulePresseActive: {
      type: Boolean,
      required: true,
    },
    filtrerProduitParSociete: {
      type: Boolean,
      required: true,
    },
    regimesTva: {
      type: Array,
      required: true,
    },
    categoriesProduct: {
      type: Array,
      required: false,
      default: () => null,
    },
  },
  components: {
    inputCurrency,
    appLignesRemise: lignesRemise,
    ligneIssueCommande,
    PopUpEditDateLigne,
    ligneCommandeDispositif,
    popUpDuplicationLigne,
    appPopupErreur: popupErreur,
  },
  data() {
    return {
      fetched: false,
      search: '',
      oldTypeRemise: null,
      typeRemiseLocal: null,
      selected: null,
      keepFirst: false,
      openOnFocus: true,
      typesProduit: [],
      listeTypeRemiseLigne: devisConf.LISTE_TYPE_REMISE_LIGNE,
      listeUniteQuantite: devisConf.LISTE_UNITES,
      isRemisesOpen: false,
      showModalChangeDate: false,
      errorPopUp: false,
      headerError: null,
      importedFunction: {
        adressFullStringGetter,
      },
      searchInMounted: false,
      constantes: {
        SENS_ACHAT: devisConf.SENS_ACHAT,
        CATEGORIE_DISPOSITIF: produitConf.CATEGORIE_DISPOSITIF,
      },
      openDetail: true,
      popUpDuplicationLigne: false,
    };
  },
  computed: {
    ...Societes.mapGetters({
      societeActiveId: 'societeActiveId',
      agenceActive: 'agenceActive',
    }),
    ...CategorieVente.mapGetters({
      categorieProduitByCode: 'categorieProduitByCode',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    getMontantBrut() {
      if (this.ligneCommande.uniteVente === POURCENTAGE) {
        return (this.ligneCommande.prixUnitaire * this.ligneCommande.quantite) / 100;
      }
      return this.ligneCommande.prixUnitaire * this.ligneCommande.quantite;
    },
    getRemiseTvaDefaut() {
      const agenceFind = this.agenceActive.find((agence) => {
        return agence.agenceId === this.devisCommande.agenceId;
      });
      if (!agenceFind || !agenceFind.regimeTvaId) return null;
      const regimeFind = this.regimesTva.find((regime) => {
        return regime.id === agenceFind.regimeTvaId;
      });
      return regimeFind ? regimeFind.tauxTva : null;
    },
    getDate() {
      if (!this.ligneCommande.dateDebut || !this.ligneCommande.dateFin) return this.$t('dateDevis.pasDate');
      return this.$t('detail.article.date', { dateDebut: formatDate(this.ligneCommande.dateDebut), dateFin: formatDate(this.ligneCommande.dateFin) });
    },
    getNumberDay() {
      if (this.ligneCommande.dateDebut && this.ligneCommande.dateFin) {
        return Number(calculDaysBetweenTwoDate(
          this.ligneCommande.dateFin, this.ligneCommande.dateDebut,
        )) + 1;
      }
      return null;
    },
    regimeTva() {
      return this.regimesTva.filter((tva) => {
        return tva.actif || this.ligneCommande.tauxTva === tva.tauxTva;
      });
    },
    getCategoriesProduct() {
      if (this.categoriesProduct) return this.categoriesProduct;
      const categories = cloneDeep(this.categorieProduitByCode);
      if (this.devisCommande.type === devisConf.TYPE_COMMANDE
        && this.devisCommande.referenceId) {
        const indexOfTempo = categories.findIndex(categorie => {
          return categorie === produitConf.CATEGORIE_REGROUPEMENT;
        });
        if (indexOfTempo !== -1) {
          categories.splice(indexOfTempo, 1);
        }
      }
      return categories;
    },
    nbLignesLibelle() {
      if (this.ligneCommande.libelle) {
        return this.ligneCommande.libelle.split('\n').length;
      }
      return 1;
    },
    unite() {
      const uniteVente = this.listeUniteQuantite.find((unite) => {
        return unite.code === this.ligneCommande.uniteVente;
      });
      if (uniteVente) {
        return uniteVente.initiale;
      }
      return '';
    },
    typeRemiseInitial() {
      const typeRemise = this.listeTypeRemiseLigne.find((type) => {
        return type.code === this.typeRemiseLocal;
      });
      if (typeRemise) {
        return typeRemise.initiale;
      }
      return '';
    },
    valeurPourcentage: {
      get() {
        return remiseF2B.toMontantRemiseFront(
          this.ligneCommande.typeRemise, this.ligneCommande.remise,
        );
      },
      set(value) {
        remiseF2B.fromMontantRemiseFront(this.ligneCommande, this.typeRemiseLocal, value);
      },
    },
  },
  mounted() {
    this.updateTypeRemiseLocal();
    if (this.ligneCommande.produit) {
      this.searchInMounted = true;
      this.ligneCommande.search = this.ligneCommande.produit.reference;
    }
  },
  methods: {
    updateDates(dates) {
      this.ligneCommande.dateDebut = dates.dateDebut;
      this.ligneCommande.dateFin = dates.dateFin;
    },
    getPrixUnitaireNet(ligne) {
      if (ligne.quantite === 0 || !ligne.quantite) return 0;
      return calculArrondi(ligne.totalHtAvecLigneRemise / ligne.quantite);
    },
    annonceurWithExonerationTva(ligne) {
      const annonceurExonererTva = this.sens === devisConf.SENS_VENTE
        && this.devisCommande.intervenants.some((int) => {
          return int.annonceur && getExonerationTva(int);
        });
      if (annonceurExonererTva) ligne.tauxTva = 0;
      return annonceurExonererTva;
    },
    updateTypeRemiseLocal() {
      this.typeRemiseLocal = remiseF2B.toTypeRemiseFront(
        this.ligneCommande.typeRemise, this.ligneCommande.remise,
      );
    },
    async selectedProduct(option) {
      if (option) {
        if (!option.id) {
          this.$refs['autocomplete_' + this.ligneCommande.ordre].setSelected(null);
          return;
        }
        let nouvelleLigneCommande = [];
        if (option.type === produitConf.CATEGORIE_UNITAIRE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitFace(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_REGROUPEMENT) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitReseauTempo(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_REGROUPEMENT_LC) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitReseauLc(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_REGROUPEMENT_MAIRIE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitReseauMairie(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitReseauNumeriqueViaId(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut,
          );
        } else if (option.type === produitConf.CATEGORIE_ECRAN_NUMERIQUE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitEcranNumeriqueViaId(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else if (option.type === produitConf.CATEGORIE_SALON) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitSalon(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else if (option.type === produitConf.CATEGORIE_SPONSORING) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitSponsoring(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else if (option.type === produitConf.CATEGORIE_AUTRE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitAutre(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else if (option.type === produitConf.CATEGORIE_PRESSE) {
          nouvelleLigneCommande = await ajoutLignesCommandeProduitPresse(
            this.devisCommande, option.id, option.idProduitEnfant, this.ligneCommande.ordre,
            this.getRemiseTvaDefaut, option.type,
          );
        } else {
          const ligne = genererLigneCommande(this.ligneCommande.ordre / 100);
          nouvelleLigneCommande.push(ligne);
          miseAJourArticle(nouvelleLigneCommande[0], this.getRemiseTvaDefaut);
          updateInfoSousLigneRegroupement(option, nouvelleLigneCommande[0], true,
            this.getRemiseTvaDefaut);
          genererCommentaireVenteForLigne(option.produit, ligne, this.lignesCommande);
        }
        if (option.type !== produitConf.CATEGORIE_REGROUPEMENT) {
          nouvelleLigneCommande[0].calculProrata = false;
        }
        // Si avoir libre, les lignes sont négatives
        if (this.devisCommande.sousType === devisConf.SOUS_TYPE_AVOIR
          || this.devisCommande.sousType === devisConf.SOUS_TYPE_AVOIR_SUR_ACOMPTE
        ) {
          nouvelleLigneCommande.forEach(ligne => {
            ligne.quantite *= -1;
            if (ligne.lignesCommande && Array.isArray(ligne.lignesCommande)) {
              ligne.lignesCommande.forEach(sousLigne => {
                sousLigne.quantite *= -1;
              });
            }
          });
        }
        const loadingComponent = this.$buefy.loading.open();
        try {
          await updateModeCalculHonoraireLigneCommandeHonoraire(
            nouvelleLigneCommande,
            this.devisCommande.intervenants,
          );
          this.calcul();
          loadingComponent.close();
        } catch (e) {
          messageErreur(this.$i18n);
          loadingComponent.close();
          throw e;
        }
        copieReferencePersonnalise(nouvelleLigneCommande, this.ligneCommande);
        addReferenceEcheancierToLigneCommande(nouvelleLigneCommande[0], this.devisCommande);
        if (this.devisCommande.sens === devisConf.SENS_ACHAT
          && (nouvelleLigneCommande[0].typeProduit === produitConf.CATEGORIE_LOCATION
            || nouvelleLigneCommande[0].typeProduit === produitConf.CATEGORIE_DIVERS)) {
          this.showModalChangeDate = true;
        }
        this.$emit('modificationLigneCommande', nouvelleLigneCommande, this.ligneCommande.ordre, option.type);
      }
    },
    searchProduct: debounce(async function searchProductC() {
      if (this.searchInMounted) {
        this.searchInMounted = false;
        return;
      }
      if (this.ligneCommande.search
        && this.ligneCommande.search.length >= 3) {
        this.fetched = true;
        this.typesProduit = await getAllProduct(
          this.ligneCommande.search,
          this.getCategoriesProduct,
          this.sens,
          this.$route.params.id ? this.devisCommande.societeId : this.societeActiveId,
          this.filtrerProduitParSociete,
          this.user.secteursId,
        );
      } else {
        this.typesProduit = [];
        this.fetched = false;
      }
    }, 500),
    calcul() {
      this.$emit('reloadTotalHt');
    },
    estRemisePersonalisee() {
      return this.ligneCommande.typeRemise === devisConf.PERSONALISE;
    },
    supprimerProduit() {
      this.lignesCommande.splice(this.lignesCommande.indexOf(this.ligneCommande), 1);
      deleteLignesEcheanciersInutiles(this.devisCommande);
      this.$emit('reloadTotalHt');
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    changerUnite(props) {
      this.ligneCommande.uniteVente = props.code;
      this.calcul();
    },
    changerTypeRemise(props) {
      this.oldTypeRemise = this.typeRemiseLocal;
      this.typeRemiseLocal = props.code;
      remiseF2B.fromTypeRemiseFront(this.ligneCommande, this.typeRemiseLocal);
      if (this.estRemisePersonalisee()) {
        this.isRemisesOpen = true;
      } else {
        this.ligneCommande.lignesRemise = [];
        this.ligneCommande.remise = 0;
      }
      this.calcul();
    },
    validationRemise(ligne) {
      this.ligneCommande.lignesRemise = ligne.lignesRemise;
      this.isRemisesOpen = false;
      this.$emit('reloadTotalHt');
    },
    openPopupForDuplicate(ligneCommandePerso) {
      if (ligneCommandePerso) {
        this.errorPopUp = true;
        this.headerError = this.$i18n.t('dcf.messages.errors.duplicatePossibility');
      } else {
        this.popUpDuplicationLigne = true;
      }
    },
    cancelRemise() {
      this.typeRemiseLocal = this.oldTypeRemise;
      remiseF2B.fromTypeRemiseFront(this.ligneCommande, this.typeRemiseLocal);
      this.isRemisesOpen = false;
    },
    toggleDetail(value) {
      this.openDetail = value ?? !this.openDetail;
    },
    makeDuplication(qte = 1) {
      this.devisCommande.lignesCommande.sort((a, b) => a.ordre - b.ordre);

      const findIndex = this.devisCommande.lignesCommande.findIndex(
        (ligne) => ligne.ordre === this.ligneCommande.ordre,
      );
      const ligneOriginale = this.devisCommande.lignesCommande[findIndex];
      const lignes = [];
      let ordre = ligneOriginale.ordre;
      const nettoyerChamps = (ligne) => {
        delete ligne.id;
        delete ligne.referenceRegroupement;
        delete ligne.referenceEcheancier;
        ligne.selected = false;
        ligne.isDuplicated = true;

        if (ligne.lignesCommande) {
          ligne.lignesCommande.forEach((sousLigne) => {
            delete sousLigne.id;
            delete sousLigne.referenceEcheancier;
            sousLigne.lignesRemise.forEach((ligneRemise) => {
              delete ligneRemise.id;
            });
          });
        }
      };

      for (let i = 0; i < qte; i += 1) {
        const clone = cloneDeep(ligneOriginale);
        nettoyerChamps(clone);

        ordre += 100;
        clone.ordre = ordre;
        initialisationOptionBlocage(clone);
        addReferenceEcheancierToLigneCommande(clone, this.devisCommande);

        lignes.push(clone);
      }
      this.devisCommande.lignesCommande.splice(findIndex + 1, 0, ...lignes);
      this.devisCommande.lignesCommande.sort((a, b) => a.ordre - b.ordre);
      this.calcul();
    },
  },
};
</script>
